module.exports = __webpack_public_path__ + "img/4.e5b58057.png";